import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import UtilFunctions from './UtilFunctions';
import serviceauth from './auth/serviceauth';
import isEmpty from 'lodash.isempty';
import { GAEvent } from './analytics';
import Header from './components/Header';
import Footer from './components/Footer';
import Autosuggestions from './components/Autosuggestions';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import StaticData from './StaticData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import ClassBanner from './components/ClassBanner';
// import Button from "react-bootstrap/Button";

const globalFields = {
  advanced: true,
  navTree: [],
  showBanner1: 'N',
  banner1: null,
  showBanner2: 'N',
  banner2: null,
  turnOffApp: false,
  termList: [],
  fullTermList: [],
  term: '',
};
const formFields = {
  subject: '',
  catalogNbr: '',
  keywords: '',
  campus: new Set(),
  session: new Set(),
  level: new Set(),
  gs: new Set(),
  gsgold: '',
  gsmaroon: new Set(),
  college: new Set(),
  units: new Set(),
  daysOfWeek: new Set(),
  honors: false,
  promod: false,
  instructor: '',
  // campusOrOnlineSelection:"A",
  searchType: 'all',
  startTime: '',
  endTime: '',
  startDate: '',
  endDate: '',
  classNbr: '',
};

function getDropdownLabel(data, filter, placeholder) {
  var label = '';
  var count = -1;
  data.forEach((option) => {
    if (filter.has(option.value)) {
      if (count < 0) label = option.label + ' ';

      count++;
    }
  });

  if (label === '')
    // no-dd-sa:javascript-browser-security/react-dangerously-inner-html
    return (
      <div
        className="btn-placeholder"
        // no-dd-sa:javascript-browser-security/react-dangerously-inner-html
        dangerouslySetInnerHTML={{ __html: placeholder }}
      ></div>
    );
  else {
    if (count > 0)
      return (
        <>
          <div className="label-wrap">{label}</div>+{count}
        </>
      );
    else return <div className="label-wrap">{label}</div>;
  }

  // return label !== "" ? label : "Select "+ placeholder
}

// Note: AdvancedSearchCatalog defines and uses its own getDropdownAriaLabel.

// Return plain-text visible label matching getDropdown's rendered label
function getDropdownLabelText(data, filter, placeholder) {
  var label = '';
  var count = -1;
  data.forEach((option) => {
    if (filter.has(option.value)) {
      if (count < 0) label = option.label + ' ';

      count++;
    }
  });

  if (label === '') return placeholder;
  if (count > 0) return `${label}+${count} additional options selected`;
  return label;
}

function getDropdown(
  label,
  name,
  data,
  filter,
  onChange,
  ariaLabel,
  ariaDescribedBy
) {
  // const data = StaticData.locationList

  return (
    <Dropdown className="filter-dropdown">
      {/* <Dropdown.Toggle id="dropdown-basic" className="advanced-search-dropdown-button asu form-control" active={false}> */}
      <Dropdown.Toggle
        active={false}
        bsPrefix="custom-dropdown-toggle"
        variant="advanced-search"
        aria-label={getDropdownLabelText(data, filter, label)}
        aria-describedby={ariaDescribedBy}
        id={`${name}-dropdown`}
      >
        {getDropdownLabel(data, filter, label)}
        <FontAwesomeIcon icon={faChevronDown} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        {data.map((item, index) => {
          return (
            <React.Fragment key={item.label}>
              <Form.Check
                type="checkbox"
                label={item.label}
                checked={filter.has(item.value)}
                value={item.value}
                onChange={onChange}
                name={name}
                mylabel={item.label}
                className="filter-check "
                tabIndex={0}
                id={item.value}
              />
              {/* <div>
                        <label className='form-check-label-bootstrap-asu text-break'>
                            <input
                                type="checkbox"
                                label={item.label}
                                checked={filter.has(item.value)}
                                value={item.value}
                                onChange={onChange}
                                name={name}
                                mylabel={item.label}
                                className="filter-check bootstrap-asu "
                                tabIndex={0}
                            />
                            <span className='pl-2'>{item.label}</span>
                            </label>
                        </div> */}
            </React.Fragment>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
}

class AdvancedSearch extends Component {
  constructor(props) {
    super(props);

    this.state = Object.assign(globalFields, formFields);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    // this.handleClearAllFilters = this.handleClearAllFilters.bind(this)
    this.handleDateFocus = this.handleDateFocus.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
  }

  async componentDidMount() {
    const appSettings = await UtilFunctions.getAppSettings();
    if (
      (appSettings != null &&
        appSettings.get('system_enabled') != null &&
        appSettings.get('system_enabled') === 'N') ||
      appSettings == null
    ) {
      //turn off app
      this.setState({
        turnOffApp: true,
      });
    } else {
      fetch(serviceauth.getRequestObject(UtilFunctions.getTermListUrl(), 'GET'))
        .then((response) => {
          if (response.status === 401) {
            serviceauth.reauth();
          }
          return response.json();
        })
        .then(async (termList) => {
          const data = UtilFunctions.parseUrl(this.props.location.search);
          // console.log(this.props.location.search)
          const term = isEmpty(data.term)
            ? [termList.currentTerm[0].value]
            : [data.term];

          var showArchiveBool = UtilFunctions.showArchive(
            term[0],
            termList.fullList
          );
          var pastTermList = UtilFunctions.getPastTermList(termList.fullList);
          var currentTermList = UtilFunctions.getCurrentTermList(
            termList.fullList
          );
          var asuOnlineSet = new Set(); //force preselecting asuonline for online students
          asuOnlineSet.add('ASUONLINE');
          //Split gold-maroon gs
          // let gsObj = {
          //     gold: new Set(),
          //     maroon: new Set()
          // }
          // if(!isEmpty(data.gen_studies)){
          //    let propGs = data.gen_studies.split(",");
          //    propGs.forEach(element => {
          //         if(element.length === 7)
          //             gsObj.gold.add(element);
          //         else
          //             gsObj.maroon.add(element);
          //    });
          // }

          //split gs from url
          let gsDesignations = UtilFunctions.getGSDesignationsFromURL(
            data.gen_studies
          );
          // console.log(gsDesignations)
          this.setState({
            currentTerm: termList.currentTerm[0].value,
            term: term,
            termList: showArchiveBool ? pastTermList : currentTermList,
            navTree: await UtilFunctions.getHeaderNavTree(term),
            subject: isEmpty(data.subject) ? '' : data.subject,
            catalogNbr: isEmpty(data.catalogNbr) ? '' : data.catalogNbr,
            keywords: isEmpty(data.keywords) ? '' : data.keywords,
            campus: isCurrentStudentOnline()
              ? asuOnlineSet
              : isEmpty(data.campus)
              ? new Set()
              : new Set(data.campus.split(',')),
            session: isEmpty(data.session)
              ? new Set()
              : new Set(data.session.split(',')),
            level: isEmpty(data.level)
              ? new Set()
              : new Set(data.level.split(',')),
            gs: isEmpty(data.gen_studies)
              ? new Set()
              : new Set(data.gen_studies.split(',')),
            gsgold: gsDesignations.gold,
            gsmaroon:
              gsDesignations.maroon.length === 0
                ? new Set()
                : new Set(gsDesignations.maroon),
            college: isEmpty(data.college)
              ? new Set()
              : new Set(data.college.split(',')),
            units: isEmpty(data.units)
              ? new Set()
              : new Set(data.units.split(',')),
            daysOfWeek: isEmpty(data.daysOfWeek)
              ? new Set()
              : new Set(data.daysOfWeek.split(',')),
            honors: isEmpty(data.honors) ? false : data.honors === 'T',
            promod: isEmpty(data.promod) ? false : data.promod === 'T',
            instructor: isEmpty(data.instructorName) ? '' : data.instructorName,
            //campusOrOnlineSelection: isEmpty(data.instructorName) ? "" : data.instructorName,
            searchType: isEmpty(data.searchType) ? 'all' : data.searchType,
            classNbr: isEmpty(data.classNbr) ? '' : data.classNbr,
            startTime: isEmpty(data.startTime) ? '' : data.startTime,
            endTime: isEmpty(data.endTime) ? '' : data.endTime,
            startDate: isEmpty(data.startDate)
              ? ''
              : UtilFunctions.convertDateToDisplay(data.startDate),
            endDate: isEmpty(data.endDate)
              ? ''
              : UtilFunctions.convertDateToDisplay(data.endDate),
            showBanner2: appSettings.get('banner_status_2'),
            banner2: appSettings.get('banner_text_2'),
          });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  handleChange(event) {
    // console.log(event.target.name + " " + event.target.value + " " + event.target.checked + " " +event.target.type)

    if (event.target.type === 'checkbox') {
      this.setState({
        [event.target.name]: event.target.checked,
      });
    } else {
      var value = event.target.value;
      if (event.target.name === 'subject') value = value.toUpperCase();

      this.setState({
        [event.target.name]: value,
      });
    }
  }

  handleCheck(event) {
    // console.log(event.target.name + " " + event.target.value + " " + event.target.checked)
    const chkName = event.target.name;
    const chkValue = event.target.value;
    var selectedList = this.state[chkName];
    //if checkbox is checked
    if (event.target.checked) {
      selectedList.add(chkValue);
    } else {
      //if checkbox is NOT checked
      selectedList.delete(chkValue);
    }
    this.setState({
      [chkName]: selectedList,
    });
  }

  handleKeyDown(event) {
    if (event.keyCode === 13) {
      this.props.history.push(
        `/catalog/classes/classlist?${UtilFunctions.getQueryStringFromState(
          this.state
        )}`
      );
    }
  }

  handleSearch(e) {
    GAEvent('Advanced Search', 'Search Classes button click');
    // console.log(`/catalog/classes/classlist?${UtilFunctions.getQueryStringFromState(this.state)}`)
    // update state with the combination of the two gs designation
    let gsMaroonFromState = this.state.gsmaroon;
    if (this.state.gsgold !== '') gsMaroonFromState.add(this.state.gsgold);

    this.setState(
      {
        gs: gsMaroonFromState,
      },
      () => {
        this.props.history.push(
          `/catalog/classes/classlist?${UtilFunctions.getQueryStringFromState(
            this.state
          )}`
        );
      }
    );
  }

  // handleClearAllFilters(e){
  //     // console.log(this.state)
  //     // var test = Object.assign(formFields,{term:this.state.currentTerm})
  //     // console.log(test)
  //     // this.setState(Object.assign(formFields,{term:this.state.currentTerm}))
  //     // this.props.history.push("/catalog/advanced")
  //     window.location.href = "/catalog/advanced";
  // }

  handleDateFocus(e) {
    //fix for ios safari not clearing date fields
    e.currentTarget.defaultValue = '';
  }

  handleDateChange(event) {
    const { name, value } = event.target;
    const userFormatted = UtilFunctions.formatDateInput(value);
    const internalFormat = UtilFunctions.convertUserDateToInternal(userFormatted);
    
    this.setState({
      [name]: internalFormat,
    });
  }

  render() {
    // const campusOrOnlineSelection = UtilFunctions.getCampusOrOnlineSelection()
    return (
      <React.Fragment>
        {this.state.turnOffApp && <Container>App is Down</Container>}

        {!this.state.turnOffApp && (
          <>
            {/* <a id="skip-to-content" className="anchor" href="https://catalog.apps.asu.edu/catalog/classes">a</a> */}
            <Container fluid={true} className="p-0 " id="main">
              <Header navTree={this.state.navTree} />
              {this.state.showBanner2 === 'Y' && (
                <ClassBanner
                  bannerColor="gray"
                  bannerHtml={this.state.banner2}
                ></ClassBanner>
              )}
              <main role="main" aria-label="Advanced Class Search">
                <Container className=" mb-5">
                  <header>
                    <h1 className=" h2 pt-4">
                      <span className="highlight-black">Class Search</span>
                    </h1>
                    <div className="row">
                      <div className="col-12 col-md-6">
                        <h2 className="mt-5 h3">Advanced Search</h2>
                      </div>
                      <div className="col-12 col-md-6  mt-md-5 ">
                        <a
                          className="float-md-end"
                          href="/catalog/advanced"
                          tabIndex={0}
                          aria-describedby="clear-filters-help"
                        >
                          Clear all filters
                        </a>
                        <span
                          id="clear-filters-help"
                          className="visually-hidden"
                        >
                          Clears all selected search criteria and reloads the
                          form with default values.
                        </span>
                      </div>
                    </div>
                  </header>

                  <section aria-label="Advanced search form section">
                    <form
                      className="admin uds-form"
                      id="skip-to-content"
                      role="search"
                      aria-label="Advanced class search form"
                      aria-describedby="form-help"
                    >
                      <div className="visually-hidden" id="form-help">
                        Use this form to search for ASU classes. All fields are
                        optional. Fill out any combination to narrow your search
                        results.
                      </div>
                      <fieldset aria-label="Search criteria">
                        <legend className="visually-hidden">
                          Class search filters
                        </legend>
                        <div className="row">
                          <div className="col-lg-2 mt-2 mt-lg-3">
                            <label htmlFor="term">Term</label>
                            <select
                              className="form-control asu form-select"
                              id="term"
                              value={this.state.term}
                              onChange={this.handleChange}
                              name="term"
                              tabIndex={0}
                            >
                              <option value="" disabled selected>
                                Select Term
                              </option>
                              {this.state.termList != null &&
                              this.state.termList.length > 0 ? (
                                this.state.termList.map((term) => (
                                  <option value={term.value} key={term.value}>
                                    {term.label}
                                  </option>
                                ))
                              ) : (
                                <option value="" key="fallback">
                                  Terms
                                </option>
                              )}
                              {/* {
                                                !this.state.showArchive &&
                                                <option value={this.state.firstPastTerm} >
                                                    Previous Terms
                                                </option>
                                            } */}
                            </select>
                          </div>
                          <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                            <label id="subject-label" htmlFor="subject">
                              Subject
                            </label>
                            <Autosuggestions
                              term={this.state.term}
                              name="subject"
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              value={this.state.subject}
                              className="asu form-control"
                              id="subject"
                              placeholder="Enter Subject"
                              aria-describedby="subject-help"
                              aria-labelledby="subject-label"
                            />
                            <div id="subject-help" className="visually-hidden">
                              Enter the subject code, for example CSE, ENG, MAT.
                            </div>
                          </div>
                          <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                            <label htmlFor="catalogNbr">Number</label>
                            <input
                              type="text"
                              className="form-control asu"
                              placeholder="Enter Number"
                              inputMode="numeric"
                              pattern="\d*"
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              name="catalogNbr"
                              value={this.state.catalogNbr}
                              id="catalogNbr"
                              aria-describedby="catalogNbr-help"
                            />
                            <div
                              id="catalogNbr-help"
                              className="visually-hidden"
                            >
                              Enter the course number (e.g. 101, 250, 480).
                            </div>
                          </div>
                          <div className="col-lg-3 mt-2 mt-lg-3 col-12">
                            <label htmlFor="keyword">Keyword search</label>
                            <input
                              type="text"
                              placeholder="Search by keyword"
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              name="keywords"
                              className="asu form-control"
                              value={this.state.keywords}
                              id="keyword"
                              aria-describedby="keyword-help"
                            />
                            <div id="keyword-help" className="visually-hidden">
                              Enter keywords (e.g. calculus, programming,
                              history).
                            </div>
                          </div>

                          <div className="col-lg-3 mt-2 mt-lg-3 col-12">
                            <label htmlFor="instructor">Instructor</label>
                            <input
                              type="text"
                              placeholder="Enter Instructor"
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              name="instructor"
                              className="asu form-control"
                              value={this.state.instructor}
                              id="instructor"
                              aria-describedby="instructor-help"
                            />
                            <div
                              id="instructor-help"
                              className="visually-hidden"
                            >
                              Enter the instructor last name (e.g. Smith,
                              Johnson).
                            </div>
                          </div>
                        </div>
                        <div className="row ">
                          <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                            <label htmlFor="classNbr">Class Number</label>
                            <input
                              type="text"
                              inputMode="numeric"
                              pattern="\d*"
                              placeholder="Enter Class Number"
                              onChange={this.handleChange}
                              onKeyDown={this.handleKeyDown}
                              name="classNbr"
                              className="asu form-control"
                              value={this.state.classNbr}
                              id="classNbr"
                              aria-describedby="classNbr-help"
                            />
                            <div id="classNbr-help" className="visually-hidden">
                              Enter the 5 digit class number.
                            </div>
                          </div>
                          <div className="col-lg-2  col-6 mt-2 mt-lg-3">
                            <label htmlFor="level-dropdown">Level</label>
                            {getDropdown(
                              'Select Level',
                              'level',
                              StaticData.levelList,
                              this.state.level,
                              this.handleCheck,
                              null,
                              'level-help'
                            )}
                            <div id="level-help" className="visually-hidden">
                              Select one or more academic levels. Press Enter to
                              open the menu, Tab to move, Space to select or
                              deselect, and Escape to close.
                            </div>
                          </div>

                          <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                            <label htmlFor="units-dropdown">
                              Number of Units
                            </label>
                            {getDropdown(
                              'Select Units',
                              'units',
                              StaticData.unitsList,
                              this.state.units,
                              this.handleCheck,
                              null,
                              'units-help'
                            )}
                            <div id="units-help" className="visually-hidden">
                              Select one or more unit values. Press Enter to
                              open, Tab to move, Space to select or deselect,
                              Escape to close.
                            </div>
                          </div>

                          {/* <div className="col-lg-3 mt-2 mt-lg-3 col-12">
                                                <label>General Studies</label>
                                                {getDropdown("Select General Studies", "gs", StaticData.gsList, this.state.gs, this.handleCheck, "select general studies")}
                                            </div> */}
                          <div className="col-lg-3 mt-2 mt-lg-3 col-12">
                            <label htmlFor="college-dropdown">
                              College/School
                            </label>
                            {getDropdown(
                              'Select College or School',
                              'college',
                              StaticData.collegeList,
                              this.state.college,
                              this.handleCheck,
                              null,
                              'college-help'
                            )}
                            <div id="college-help" className="visually-hidden">
                              Select one or more colleges or schools.
                            </div>
                          </div>

                          <div className="col-lg-3 mt-2 mt-lg-3 col-12">
                            <label htmlFor="">Location</label>
                            {
                              //online students
                              isCurrentStudentOnline() &&
                                getDropdown(
                                  'Select location(s)',
                                  'campus',
                                  StaticData.onlineLocationList,
                                  this.state.campus,
                                  this.handleCheck,
                                  null,
                                  'location-help'
                                )
                            }
                            {
                              //everyone else
                              !isCurrentStudentOnline() &&
                                getDropdown(
                                  'Select location(s)',
                                  'campus',
                                  StaticData.locationList,
                                  this.state.campus,
                                  this.handleCheck,
                                  null,
                                  'location-help'
                                )
                            }
                            <div id="location-help" className="visually-hidden">
                              Select one or more class locations / campuses.
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                            <label htmlFor="session-dropdown">Session</label>
                            {getDropdown(
                              'Select Session',
                              'session',
                              StaticData.sessionsList,
                              this.state.session,
                              this.handleCheck,
                              null,
                              'session-help'
                            )}
                            <div id="session-help" className="visually-hidden">
                              Select one or more session codes.
                            </div>
                          </div>

                          {/* <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                                        <label>Start Time</label>
                                        <input type="time"
                                            className="form-control asu"
                                            placeholder="Start Time"
                                            onChange={this.handleChange}
                                            onKeyDown={this.handleKeyDown}
                                            name="startTime"
                                            value={this.state.startTime}
                                        />
                                    </div>
                                    <div className="col-lg-2 col-6 mt-2 mt-lg-3">
                                        <label>End Time</label>
                                        <input type="time"
                                            className="form-control asu"
                                            placeholder="End Time"
                                            onChange={this.handleChange}
                                            onKeyDown={this.handleKeyDown}
                                            name="endTime"
                                            value={this.state.endTime} />
                                    </div> */}
                          <div className="col-lg-4 mt-2 mt-lg-3 col-12">
                            <label htmlFor="daysOfWeek-dropdown">
                              Days of the Week
                            </label>
                            {getDropdown(
                              'Select Day(s)',
                              'daysOfWeek',
                              StaticData.daysOfWeekList,
                              this.state.daysOfWeek,
                              this.handleCheck,
                              null,
                              'daysOfWeek-help'
                            )}
                            <div
                              id="daysOfWeek-help"
                              className="visually-hidden"
                            >
                              Select one or more meeting days.
                            </div>
                          </div>
                          <div className="col-lg-3 col-6 mt-2 mt-lg-3">
                            <label htmlFor="startDate">Start Date</label>
                            <input
                              type="text"
                              className="form-control asu"
                              placeholder="MM/DD/YYYY"
                              onChange={this.handleDateChange}
                              onKeyDown={this.handleKeyDown}
                              name="startDate"
                              value={UtilFunctions.convertInternalDateToUser(this.state.startDate)}
                              onFocus={this.handleDateFocus}
                              id="startDate"
                              aria-describedby="startDate-help"
                              maxLength="10"
                              inputMode="numeric"
                            />
                            <div id="startDate-help" className="sr-only">
                              Filter classes that start on or after this date. Enter date in format month month slash day day slash year year year year.
                            </div>
                          </div>
                          <div className="col-lg-3 col-6 mt-2 mt-lg-3">
                            <label htmlFor="endDate">End Date</label>
                            <input
                              type="text"
                              className="form-control asu"
                              placeholder="MM/DD/YYYY"
                              onChange={this.handleDateChange}
                              onKeyDown={this.handleKeyDown}
                              name="endDate"
                              value={UtilFunctions.convertInternalDateToUser(this.state.endDate)}
                              onFocus={this.handleDateFocus}
                              id="endDate"
                              aria-describedby="endDate-help"
                              maxLength="10"
                              inputMode="numeric"
                            />
                            <div id="endDate-help" className="sr-only">
                              Filter classes that end on or before this date. Enter date in format month month slash day day slash year year year year.
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-4  col-12 mt-2 mt-lg-3">
                            <label
                              htmlFor="gsgold"
                              className="gs-label gs-label-gold gs-header"
                            >
                              General Studies Gold
                            </label>
                            <p className="mt-1" id="gs-gold-help">
                              {StaticData.GS_GOLD_TEXT}
                            </p>
                            {/* {getDropdown("Select General Studies Gold", "gs", StaticData.gsListGold, this.state.gs, this.handleCheck, "select general studies")} */}
                            <select
                              className="form-control asu form-select"
                              id="gsgold"
                              value={this.state.gsgold}
                              onChange={this.handleChange}
                              name="gsgold"
                              tabIndex={0}
                              aria-describedby="gs-gold-help"
                            >
                              <option value={''} key={'empty'} className="">
                                Select General Studies Gold
                              </option>
                              {StaticData.gsListGold.map((myGs) => {
                                return (
                                  <option value={myGs.value} key={myGs.value}>
                                    {myGs.label}
                                  </option>
                                );
                              })}
                            </select>
                          </div>

                          <div className="col-lg-4  col-12 mt-2 mt-lg-3">
                            <label
                              htmlFor="gsmaroon-dropdown"
                              className="gs-label gs-label-maroon gs-header"
                              id="gsmaroon-label"
                            >
                              General Studies Maroon
                            </label>
                            <p className="mt-1" id="gs-maroon-help">
                              {StaticData.GS_MAROON_TEXT}
                            </p>
                            {getDropdown(
                              'Select General Studies Maroon',
                              'gsmaroon',
                              StaticData.gsListMaroon,
                              this.state.gsmaroon,
                              this.handleCheck,
                              null,
                              'gs-maroon-help'
                            )}
                          </div>
                          <div className="col-lg-1  col-12 mt-2 mt-lg-3 d-none d-lg-block"></div>
                          <div className="col-lg-2  col-6 mt-2 mt-lg-3">
                            <div className="fw-bold mb-2" id="class-status-heading">Class Status</div>
                            <div className="form-check mt-0">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="searchType"
                                value="open"
                                id="search-open"
                                onChange={this.handleChange}
                                checked={this.state.searchType === 'open'}
                              />
                              <label
                                htmlFor="search-open"
                                className="form-check-label"
                              >
                                Open Seats
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="searchType"
                                value="all"
                                id="search-all"
                                onChange={this.handleChange}
                                checked={this.state.searchType === 'all'}
                              />
                              <label
                                htmlFor="search-all"
                                className="form-check-label"
                              >
                                All Classes
                              </label>
                            </div>
                          </div>
                          <div className="col-lg-1  col-6 mt-2 mt-lg-3">
                            <label htmlFor="honors-check">Honors</label>
                            <div>
                              <input
                                type="checkbox"
                                className="bootstrap-asu"
                                name="honors"
                                value="T"
                                checked={this.state.honors}
                                onChange={this.handleChange}
                                style={{ width: '20px', height: '20px' }}
                                id="honors-check"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-lg-2 mt-2 mt-lg-3">
                            <button
                              id="search-button"
                              type="button"
                              className="btn-xl btn btn-gold"
                              onClick={this.handleSearch}
                              aria-describedby="search-button-help"
                            >
                              <FontAwesomeIcon
                                icon={faSearch}
                                className="me-2"
                              />
                              Search Classes
                            </button>
                            <div
                              id="search-button-help"
                              className="visually-hidden"
                            >
                              Runs the search using the selected filters.
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </form>
                  </section>
                </Container>
              </main>
              <Footer />
            </Container>
          </>
        )}
      </React.Fragment>
    );
  }
}
export default AdvancedSearch;

function isCurrentStudentOnline() {
  return (
    sessionStorage.getItem(serviceauth.SS_IS_STUDENT) === 'Y' &&
    sessionStorage.getItem(serviceauth.SS_IS_ONLINE) === 'Y' &&
    sessionStorage.getItem(serviceauth.SS_IS_STAFF) === 'N'
  );
}
